<template>
  <el-dropdown
    trigger="click"
    class="international"
    @command="handleSetLanguage"
  >
    <div>
      <!-- <svg-icon class-name='international-icon' icon-class="language" /> -->
      <img src="../assets/img/language.png" alt="" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh" :disabled="language === 'zh'"
        >中文</el-dropdown-item
      >
      <el-dropdown-item command="vi" :disabled="language === 'vi'"
        >tiếng việt</el-dropdown-item
      >
      <el-dropdown-item command="en" :disabled="language === 'en'"
        >English</el-dropdown-item
      >
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch("setLanguage", lang);
      this.$message({
        message: this.$t("alertMsg.switchSuccess"),
        type: "success"
      });
    }
  }
};
</script>

<style scoped>
.international {
  cursor: pointer;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 4px;
}
</style>
